import { SimpleGrid, Checkbox } from '@mantine/core'

// #1080 検索サイドバー「こだわり条件」。チェック状態の判定・送信はRails側の通常のフォーム送信に任せ、
// ここではMantineのCheckboxで見た目だけを差し替える(uncontrolled/defaultChecked)。
export default function ConditionCheckboxGroup({ items = [], cols = 2 }) {
  return (
    <SimpleGrid cols={{ base: 1, xs: cols }} spacing="xs" verticalSpacing={8}>
      {items.map((item) => (
        <span key={item.id}>
          {item.uncheckedValue !== undefined && (
            <input type="hidden" name={item.name} value={item.uncheckedValue} />
          )}
          <Checkbox
            id={item.id}
            name={item.name}
            value={item.value}
            defaultChecked={item.checked}
            label={item.label}
            size="sm"
            styles={{ body: { alignItems: 'center' }, labelWrapper: { alignItems: 'center' } }}
          />
        </span>
      ))}
    </SimpleGrid>
  )
}
